import APIOperationResultImages from '@/api/modules/operation-result-images';

const initialState = {
  imagesByClinic: [],
};

export default {
  namespaced: true,
  state: initialState,
  getters: {
    images: (state) => {
      if (!state.imagesByClinic || !state.imagesByClinic.length) return [];
      return state.imagesByClinic[0].images || [];
    },
  },
  mutations: {
    SET_DATA(state, { type, data }) {
      state[type] = data;
    },
  },
  actions: {
    async fetch({ commit }, params) {
      const { data } = await APIOperationResultImages.list(params);
      commit('SET_DATA', { type: 'imagesByClinic', data: data || [] });
    },
    upload(_, payload) {
      return APIOperationResultImages.upload(payload);
    },
    update(_, payload) {
      return APIOperationResultImages.update(payload);
    },
    remove(_, id) {
      return APIOperationResultImages.remove(id);
    },
  },
};
